// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1_fiL","cls2":"SimplePaperPodcast-cls2_lQP SimplePaperPodcast-cls1_fiL"};